import { SupplierShopsList } from "./shopTypes"
import { AxiosInstance } from "axios"

export enum SupplierShopQuery {
    SHOPS_LIST = "shops-list",
}

type SupplierShopsListParams = Readonly<{
    supplierId: number
    merchantIds: string
}>

export type SupplierShopsListResponse = Readonly<{
    merchants: Array<SupplierShopsList>
}>

export async function fetchSupplierShopsList(
    { supplierId, merchantIds }: SupplierShopsListParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SupplierShopsListResponse> {
    const url = `/suppliers/${supplierId}/shops`

    const response = await axios.get(url, {
        params: { merchantIds },
        signal,
    })

    return response.data
}
